<script setup lang="ts">
	useIntercom()
</script>
<template>
	<main>
		<client-only>
			<u-notifications class="!bottom-6" :ui="{wrapper: 'w-full pointer-events-none z-[10000]'}" />
			<nuxt-loading-indicator color="#1F7A66" :height="5" />
		</client-only>
		<div>
			<nuxt-layout />
		</div>
	</main>
</template>
